export const CART_ERRORS_MAP = {
    CART_ALREADY_COMPLETED: "CART_ALREADY_COMPLETED",
    SLOT_TIMEOUT: "SLOT_TIMEOUT",
    SLOT_FULL: "SLOT_FULL",
};

export const handleCompletedCartError = (errors) => {
    if (errors.includes(CART_ERRORS_MAP.CART_ALREADY_COMPLETED)) {
        window.location.href = `${window.location.origin}/thank-you`;
        return true;
    }

    return false;
};

export const checkForSlotErrors = (errors) => {
    return (
        errors?.some(
            (err) =>
                err === CART_ERRORS_MAP.SLOT_FULL ||
                err === CART_ERRORS_MAP.SLOT_TIMEOUT
        ) || false
    );
};
